import { render, staticRenderFns } from "./Replace.vue?vue&type=template&id=b2e2a5b8&scoped=true&"
import script from "./Replace.vue?vue&type=script&lang=js&"
export * from "./Replace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e2a5b8",
  null
  
)

export default component.exports